import { createPortal } from 'react-dom'
import { useEffect } from 'react'

import { AppIcon } from './AppIcon'

type AppToastProps = {
  autoHideDuration?: number | null
  message: string
  onClose: () => void
  open: boolean
  severity?: 'error' | 'info' | 'success' | 'warning'
}

export function AppToast({
  autoHideDuration = 3_000,
  message,
  onClose,
  open,
  severity = 'info',
}: AppToastProps) {
  useEffect(() => {
    if (!open || autoHideDuration === null) return
    const timer = window.setTimeout(onClose, autoHideDuration)
    return () => window.clearTimeout(timer)
  }, [autoHideDuration, onClose, open])

  if (!open || typeof document === 'undefined') return null

  return createPortal(
    <div
      aria-live="polite"
      className={`app-toast app-toast-${severity}`}
      role="status"
    >
      <span className="app-toast-message">{message}</span>
      <button aria-label="Закрыть уведомление" onClick={onClose} type="button">
        <AppIcon name="close" />
      </button>
    </div>,
    document.body,
  )
}
